export default [
  { path: "/welcome", name: "欢迎", icon: "smile", component: "./Welcome" },
  {
    path: "/finance",
    name: "金融管理",
    icon: "accountBook",
    routes: [
      {
        path: "/finance/application",
        name: "申请管理",
        component: "./Finance/Application",
      },
      {
        path: "/finance/order",
        name: "订单管理",
        component: "./Finance/Order",
      },
      {
        path: "/finance/order/:id",
        name: "订单详情",
        component: "./Finance/Order/Detail",
        hideInMenu: true,
        permissionPath: "/finance/order",
      },
      {
        path: "/finance/customer",
        name: "客户管理",
        component: "./Finance/Customer",
      },
      {
        path: "/finance/vehicle",
        name: "车辆管理",
        component: "./Finance/Vehicle",
      },
      {
        path: "/finance/dealer",
        name: "车商管理",
        component: "./Finance/Dealer",
      },
      {
        path: "/finance/provider",
        name: "资方管理",
        component: "./Finance/Provider",
      },
      {
        path: "/finance/policy",
        name: "政策管理",
        component: "./Finance/Policy",
      },
      {
        path: "/finance/company-bank-account",
        name: "公司账号",
        component: "./Finance/CompanyBankAccount",
      },
    ],
  },
  {
    path: "/carloan",
    name: "车贷管理",
    icon: "payCircle",
    routes: [
      {
        path: "/carloan/customer",
        name: "客户管理",
        component: "./Carloan/Customer",
      },
      {
        path: "/carloan/order",
        name: "订单管理",
        component: "./Carloan/Order",
      },
      {
        path: "/carloan/vehicle",
        name: "车辆管理",
        component: "./Carloan/Vehicle",
      },
    ],
  },
  {
    path: "/vehicle",
    name: "车辆管理",
    icon: "car",
    routes: [
      {
        path: "/vehicle/inbound",
        name: "入库管理",
        component: "./Vehicle/Inbound",
      },
      {
        path: "/vehicle/outbound",
        name: "出库管理",
        component: "./Vehicle/Outbound",
      },
    ],
  },
  {
    path: "/im",
    name: "即时通讯",
    icon: "message",
    routes: [
      {
        path: "/im/account",
        name: "账号管理",
        component: "./Im/Account",
      },
      {
        path: "/im/contact",
        name: "联系人",
        component: "./Im/Contact",
      },
      {
        path: "/im/message",
        name: "消息记录",
        component: "./Im/Message",
      },
      {
        path: "/im/template",
        name: "消息模板",
        component: "./Im/Template",
      },
    ],
  },
  {
    path: "/trace",
    name: "视频溯源",
    icon: "videoCamera",
    routes: [
      { path: "/trace/recorder", name: "录像机管理", component: "./Trace/Recorder" },
      { path: "/trace/channel", name: "通道管理", component: "./Trace/Channel" },
      { path: "/trace/scanner", name: "设备管理", component: "./Trace/Scanner" },
      { path: "/trace/scan", name: "扫码记录", component: "./Trace/Scan" },
    ],
  },
  {
    path: "/common",
    name: "系统管理",
    icon: "setting",
    routes: [
      { path: "/common/dept", name: "部门管理", component: "./Common/Dept" },
      { path: "/common/user", name: "用户管理", component: "./Common/User" },
      { path: "/common/role", name: "角色管理", component: "./Common/Role" },
      { path: "/common/system-config", name: "系统配置", component: "./Common/SystemConfig" },
      { path: "/common/log", name: "日志列表", component: "./Common/Log" },
      { path: "/common/request", name: "请求日志", component: "./Common/Request" },
    ],
  },
  { path: "/login", name: "登录", component: "./Login", layout: false },
  { path: "/", redirect: "/welcome" },
  { path: "/403", layout: false, component: "./403" },
  { path: "*", layout: false, component: "./404" },
];
